export default __webpack_public_path__ + "static/media/noSQL.67e58275.svg";